module.exports = __webpack_public_path__ + "561aaf2f025c967e030dc35138d26c18.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/avatars/AvatarChloe5.png
// module id = 148
// module chunks = 0